module.exports = __webpack_public_path__ + "img/hr-level3addon_idle_mask.bb836ccf.png";